import * as React from 'react';
import styled from 'styled-components';

export interface IStyledInput {
    smallInput?: boolean;
    left?: boolean;
    right?: boolean;
}

export type InputWrapperType = React.ComponentType<IStyledInput & React.HTMLProps<HTMLDivElement>>;
export const InputWrapper: InputWrapperType = styled.div`
    width: 100%;
    display: inline-block;
    margin: 0;
    vertical-align: top;
`;
InputWrapper.displayName = 'InputWrapper';

export const InfoWrapper: React.ComponentType = styled.div`
    text-align: right;
    font-style: italic;
    padding-right: 10px;

    [dir='rtl'] & {
        text-align: left;
    }
`;
InfoWrapper.displayName = 'InfoWrapper';
